<div class="justify-content-center">
  <h1 class="text-center text-white">About the band</h1>
  <div class="row mx-3 mb-4">
    <div class="col-lg-6" data-aos="fade-right">
      <p class="text-center">
We are an alternative rock band from Landen, Belgium, playing a mix of covers and original songs.
      </p>
      <p class="text-center">
Argon was founded in 2016 by Pieter and Billy. Both had been involved in several musical projects before, but none had really taken off. Soon, Robin joined on bass guitar and the trio started playing covers while working on their first original songs.
      </p>
      <p class="text-center">
One thing was still missing: a drummer. After a long search, they found Viktor, a cello player who was somehow convinced to switch to bass guitar, while Robin moved behind the drums. Viktor also brought along a new song idea, giving Billy the perfect excuse to dust off his harmonica. One of our now iconic songs, The Friendship Song, was born and the first official Argon line-up was complete.
      </p>
      <p class="text-center">
By 2018, we were ready for our first gig at Lokale Helden in Landen. There was just one problem: we still didn't have a band name. The night before the line-up announcement, Billy suggested *Argon*, and we immediately knew it was the right choice.
      </p>
      <p class="text-center">
Since then, we've been writing songs, playing gigs, and making memories. When Robin's fingers started itching to shred some guitar again, he met Arne, an awesome drummer. Arne never made it to his first Argon gig because he got stuck in a pub in Landen. Luckily, the beers were good enough for him to join the band anyway. Since then, our beats have never been tighter. The rest, as they say, is history. 
      </p>
    </div>

    <div class="col-lg-6 d-none d-md-block">
      <img
        [src]="imageUrl"
        class="about-image scrolling-image"
        alt="The band posing with their instruments"
        data-aos="fade-left"
      />
    </div>
  </div>
</div>
